import { IMedicalOrderPosition } from '@alberta/konexi-shared';
import { MedicalOrderNodeValue } from 'src/app/shared/models/medical-order/medical-order-node-value';
import { MedicalOrderPositionViewModel } from '../view-models/medical-order-position-view-model';

export function convertOrderedServiceLines(medicalOrder: MedicalOrderNodeValue): IMedicalOrderPosition[] {
  const positions = [];
  for (const serviceLine of medicalOrder.serviceLines ?? []) {
    const position = new MedicalOrderPositionViewModel();
    position.name = serviceLine.service.name;
    position.serviceId = serviceLine.service._id;
    position.dosage = serviceLine.dosage;
    position.startDate = medicalOrder.startDate;
    position.endDate = medicalOrder.endDate;
    position.description = serviceLine.service.description;
    positions.push(position);
  }
  return positions;
}
